// import { default as ModernDrawer } from "react-modern-drawer";
// import Drawer, { DrawerProps } from 'rc-drawer';
// import 'rc-drawer/assets/index.css';
import { useState, useEffect } from "@wordpress/element";
import IconClose from "./IconClose";

const Drawer = (props) => {
	const { open, placement, onClose } = props;


	return (
		<>
			<div
				className={`drawer-overlay ${!open && 'h'} ${open && 'o'
					}`}
				onClick={onClose}
				aria-hidden="true"
			/>
			<div
				tabIndex="-1"
				style={{
					width: props?.width,
					height: props?.height,
				}}
				className={`drawer ${open && 'animate'} ${!open && 'h'
					} ${placement || 'right'} ${props.className || ''}`}
			>
				<div className="drawer-inner">{props.children}</div>
			</div>
		</>
	);
};


const AppDrawer = ({ isOpen, onClose, title, footer, children }) => {
	const [width, setWidth] = useState(window.innerWidth);
	const [height, setHeight] = useState(window.innerHeight);
	useEffect(() => {
		const handleResize = () => {
			setWidth(window.innerWidth);
			setHeight(window.innerHeight);
		};

		window.addEventListener("resize", handleResize);

		return () => {
			window.removeEventListener("resize", handleResize);
		};
	}, []);


	return (
		<Drawer
			open={isOpen}
			onClose={onClose}
			placement={width > 600 ? "right" : "bottom"}
			className="sasw_drawer sasw_attr_drawer_values"
			zIndex={999900}
			width={width > 600 ? 450 : '100%'}
			height={width > 600 ? '100%' : height * 0.6}
			forceRender
		>
			<div className="sasw_drawer_wrap">
				<div className="sasw_drawer_head">
					<div className="sasw_drawer_head_inner">
						{title && <div className="sasw_drawer_title">{title}</div>}

						<div className="sasw_drawer_actions">
							<span className="sasw_drawer_btn sasw_close sasw_cursor" onClick={onClose}>
								<IconClose />
							</span>
						</div>
					</div>
				</div>
				<div className="sasw_drawer_body">{children}</div>
				{footer && (
					<div className="sasw_drawer_footer">
						<div className="sasw_drawer_footer_inner">{footer}</div>
					</div>
				)}
			</div>
		</Drawer>
	);
};

export default AppDrawer;
